import { TextField, Typography } from "@mui/material"
import styled from "@emotion/styled"

export const InputContainer = styled.div`
  &.margin-top {
    margin-top: 1em;
  }

  &.text-area {
    .MuiOutlinedInput-root {
      border-radius: 20px;
      padding-top: 0.5em;
      padding-bottom: 0.5em;
    }
    input {
      padding: 0em 1em;
    }
  }

  &.border-radius-8 {
    .MuiInputBase-multiline {
      border-radius: 8px;
    }
  }
`

export const Title = styled(Typography)`
  font-size: ${({ theme }) => theme.typography.pxToRem(14)};
  line-height: ${({ theme }) => theme.typography.pxToRem(14)};
  font-style: normal;
  font-weight: 400;
  letter-spacing: -0.14px;
  color: ${({ theme }) => theme.palette.text.content};
  font-family: ${({ theme }) => theme.fonts.tertiary};
  margin-bottom: 8px;
`

export const CustomInput = styled(TextField)`
  font-weight: 500;
  font-size: 1rem;
  line-height: 19px;
  letter-spacing: -0.01em;

  //opacity: 0.5;
  width: 100%;
  .MuiInputLabel-root {
    font-family: ${({ theme }) => theme.fonts.secondary};
    color: #5f5f5f;
    padding: 0;
    font-size: 0.875rem;
    /* opacity: 0.5; */
  }
  .MuiInputBase-input {
    padding: 0.875rem 0.75rem;
    font-family: ${({ theme }) => theme.fonts.secondary};
    background: #fff;
    color: #5f5f5f;
  }
  .MuiInputBase-root {
    padding: 0;
    :hover {
      .MuiOutlinedInput-notchedOutline {
        border-color: ${({ theme }) => theme.palette.primary.dark};
      }
    }
  }
  .MuiOutlinedInput-notchedOutline,
  fieldset {
    border: none;
  }

  .Mui-focused {
    .MuiOutlinedInput-notchedOutline {
      border-color: ${({ theme }) => theme.palette.primary.dark};
    }
    fieldset {
      border-color: ${({ theme }) => theme.palette.primary.dark};
    }
    &.Mui-error {
      fieldset {
        border-color: ${({ theme }) => theme.palette.primary.dark} !important;
      }
    }
  }

  .MuiFormHelperText-root.Mui-error {
    font-family: ${({ theme }) => theme.fonts.tertiary};
    margin-left: 14px;
  }
  legend {
    position: relative;
    /* > span {
      padding-right: 0.75rem;
    } */
  }
`
